import { useEffect, type Dispatch, type SetStateAction } from 'react'
import type { EliteOnboardingStatusResponse } from '../../../types/misc.types'
import {
  isYearlyPlanTenure,
  mapSelectedPlanDetailsToPlanConfig
} from '../components/NewEliteLandingPlanSelector'
import type { EliteLandingPlan } from '../planTypes'

export function useSyncEliteLandingPlanFromEligiblePlans(
  eligiblePlans: EliteOnboardingStatusResponse['eligiblePlans'],
  setSelectedPlan: Dispatch<SetStateAction<EliteLandingPlan>>,
  selectedPlanDetails?: EliteOnboardingStatusResponse['selectedPlanDetails']
) {
  useEffect(() => {
    const planFromSelectedDetails = mapSelectedPlanDetailsToPlanConfig(selectedPlanDetails, eligiblePlans)
    if (planFromSelectedDetails?.type) {
      setSelectedPlan(planFromSelectedDetails.type)
      return
    }

    if (eligiblePlans?.length === 0) return
    if (eligiblePlans.some((plan) => isYearlyPlanTenure(plan?.effectivePlanTenure ?? plan?.basePlanTenure))) {
      setSelectedPlan('yearly')
      return
    }
    if (eligiblePlans.some((plan) => (plan?.effectivePlanTenure ?? plan?.basePlanTenure)?.period === 'MONTH')) {
      setSelectedPlan('monthly')
    }
  }, [eligiblePlans, selectedPlanDetails, setSelectedPlan])
}
